<svg width="36" height="40" viewBox="0 0 36 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M18 20c5.681 0 10.286-4.477 10.286-10S23.68 0 18 0C12.319 0 7.714 4.477 7.714 10S12.32 20 18 20zm7.2 2.5h-1.342a14.34 14.34 0 0 1-11.716 0H10.8C4.837 22.5 0 27.203 0 33v3.25C0 38.32 1.728 40 3.857 40h28.286C34.273 40 36 38.32 36 36.25V33c0-5.797-4.837-10.5-10.8-10.5z" id="jzjr0yp3wa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="x80ur05f6b" fill="#fff">
            <use xlink:href="#jzjr0yp3wa"/>
        </mask>
        <use fill="#646E82" fill-rule="nonzero" xlink:href="#jzjr0yp3wa"/>
        <g mask="url(#x80ur05f6b)" fill="currentColor">
            <path d="M-27.788-49.23h92.5V89.23h-92.5z"/>
        </g>
    </g>
</svg>
